module.exports = __webpack_public_path__ + "static/media/cc-dev-jun.6ac36be3.png";